import React from "react"
import { Box, Stack } from "@chakra-ui/react"

import {
  LearnPage,
  LearnPageAttributes,
  LearnPageBadges,
  LearnPageDescription,
  LearnPageImage,
  LearnPageTitle,
} from "@components/LearnPage"

export interface ArticleCarouselItemProps {
  item: NormalisedArticle
  handleTrackingClick: VoidFunction
  hideBadges?: boolean
}

const ArticleCarouselItem = (props: ArticleCarouselItemProps) => (
  <Box mb={3.5}>
    <LearnPage {...props}>
      <LearnPageImage height={"100%"} />
      <Stack my={2}>
        {props.hideBadges ? null : <LearnPageBadges />}
        <LearnPageTitle />
        <LearnPageDescription />
        <LearnPageAttributes />
      </Stack>
    </LearnPage>
  </Box>
)

export default React.memo(ArticleCarouselItem)
